import React from 'react'
import Social from '../Layout/Social'

export default function Footer(props) {
  let formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return phoneNumberString
  }
  
  return (
    <div className="footer-container">
      <footer>
        <div className="footer-content">
            <div className="church-info">
                {/* Add phone and email icon */}
                <p><strong>Contact Us</strong></p>
                <div className="contact_us">
                  <p className='contact-info'><span><i className="las la-phone"></i></span> <a href={`tel:${props.data.phoneNumber}`}>{formatPhoneNumber(props.data.phoneNumber)}</a></p>
                  <p><span> <span><i className="lar la-envelope"></i></span> <a href={`mailto: ${props.data.email}`}> {props.data.email} </a></span></p>
                  <p><span> <span><i class="las la-globe"></i></span> <a href= {props.data.website} target="_blank"> {props.data.contactWeb} </a></span></p>
                </div>
                <br/>
                <div className="church-website">
                    <h4><i class="las la-map-marker"></i><a href={`http://maps.google.com/?q=${props.data.address}`} target="_blank">{props.data.address}</a> </h4>
                </div>
            </div>

            <div className="churchpad-info">
              <p>© Copyright  2020. ChurchPad All Rights Reserved</p>
            </div>

            <div className="center privacy">
              <a href={props.data.privacy} target="_blank">
                <p>Privacy Policy</p>
              </a>
              <a href={props.data.tos} target="_blank">
                <p>Terms of Service</p>
              </a>
            </div>

            <Social data={props.data.social}/>
        </div>
      </footer>
    </div>
  )
}